import * as React from 'react';
import { useEffect, useState } from 'react';

import { Color, IconName } from '../../enums';
import { UseState } from '../../types';
import { Icon } from '../icon/icon.component';

import { CloseButton, Container, StyledMarkdown } from './toast.styled';
import { ToastProps } from './toast.types';

export const Toast: React.FC<ToastProps> = (props: ToastProps) => {
  const { content, visible = true, className, onClose, single = false, withCloseButton = false }: ToastProps = props;
  const [isVisible, setIsVisible]: UseState<boolean> = useState<boolean>(true);
  const [isDestroyed, setIsDestroyed]: UseState<boolean> = useState<boolean>(false);

  useEffect(
    (): void => {
      if (single && visible !== isVisible) {
        setIsVisible(visible);
      }
    },
    [visible]
  );

  useEffect(
    (): (() => void) | void => {
      if (!single) {
        const timeout: NodeJS.Timeout = setTimeout(() => closeAction(), 3500);

        return (): void => clearTimeout(timeout);
      }
    },
    []
  );

  const closeAction: () => void = (): void => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
    setTimeout((): void => setIsDestroyed(true), 500);
  };

  return (
    <Container
      className={className}
      $visible={isVisible}
      $destroyed={isDestroyed}
      $single={single}
    >
      <StyledMarkdown text={content} />
      {withCloseButton && (
        <CloseButton onClick={closeAction}>
          <Icon
            name={IconName.CloseSmaller}
            size={16}
            color={Color.White}
          />
        </CloseButton>
      )}
    </Container>
  );
};
